import { commonThinxHeaders, jsonPut } from 'api'

export const updateAccount = (token, accountKey, name, dateAdded, details, currentLocale) => {
    const { emailAddress, firstName, lastName, phone, billingAddress, deliveryAddress } = details

    return jsonPut(
        `${THINX_ACCOUNT_URL}/subscription/account/`,
        undefined,
        {
            id: accountKey,
            name,
            type: 'INDIVIDUAL',
            owner: {
                firstName,
                lastName,
                contact: {
                    email: [
                        {
                            mode: 'EMAIL',
                            type: null,
                            primary: true,
                            email: emailAddress,
                        },
                    ],
                    phone: null,
                    mobile: [
                        {
                            mode: 'PHONE',
                            type: null,
                            primary: true,
                            countryCode: null,
                            countryDialingCode: null,
                            extension: null,
                            value: details.phone,
                            normalizedValue: null,
                            nationalNumber: null,
                        },
                    ],
                    fax: null,
                    url: null,
                    preferred: null,
                    assistant: null,
                },
            },
            users: [
                {
                    userId: emailAddress,
                    firstName,
                    lastName,
                    email: emailAddress,
                    locale: 'en_US',
                    dateAdded,
                    srcInternal: false,
                },
            ],
            addresses: [
                {
                    type: 'BILLING',
                    city: billingAddress.city,
                    country: billingAddress.country,
                    line1: billingAddress.address1,
                    line2: billingAddress.address2,
                    zip: billingAddress.postalCode,
                    state: billingAddress.state,
                },
                {
                    type: 'HOME',
                    city: deliveryAddress.city,
                    country: deliveryAddress.country,
                    line1: deliveryAddress.address1,
                    line2: deliveryAddress.address2,
                    zip: deliveryAddress.postalCode,
                    state: deliveryAddress.state,
                },
            ],
            contacts: [
                {
                    firstName,
                    lastName,
                    email: emailAddress,
                    phone: phone,
                    contactType: 'BILLING',
                },
            ],
            preferredLocale: currentLocale,
        },
        commonThinxHeaders(token, false, { 'Content-Type': 'application/json' })
    ).catch(error => {
        throw new Error(error.message)
    })
}
